import React, { useEffect, useState } from "react";
import useApi from "../../../CustomHooks/useApi";

const IMPSRouting = () => {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [operators, setOperators] = useState([]);

  const [showOperatorModal, setShowOperatorModal] = useState(false);
  const [selectedOperator, setSelectedOperator] = useState("");
  const [operatorStatus, setOperatorStatus] = useState(true);

  const [operatorResponse, setOperatorResponse] = useState(null);
  const [showResponseModal, setShowResponseModal] = useState(false);

  const [formData, setFormData] = useState({
    minAmount: "",
    maxAmount: "",
    // rules: [{ operator: "", percentage: "", priority: 1, active: true }],
    rules: [
      { operator: "", percentage: "", priority: 1, active: true },
      { operator: "", percentage: "", priority: 2, active: true },
      { operator: "", percentage: "", priority: 3, active: true },
      { operator: "", percentage: "", priority: 4, active: true },
      { operator: "", percentage: "", priority: 5, active: true },
    ],
  });

  const [errorMsg, setErrorMsg] = useState("");

  const { callApi: getAllRules } = useApi(
    "/admin/routing/rules/grouped",
    "GET"
  );

  const { callApi: createRule } = useApi(
    "/admin/routing/rule/slab",
    "POST"
  );

  const { callApi: updateRule } = useApi(
    "/admin/routing/rule/slab",
    "POST"
  );

  const { callApi: getOperators } = useApi(
    "/admin/operator",
    "GET"
  );

  const { callApi: updateOperator } = useApi("/admin/operator/toggle", "POST");

  // ================= FETCH =================
  const fetchRules = async () => {
    setLoading(true);
    try {
      const res = await getAllRules(null, `?paymentMode=IMPS`);
      setRules(Array.isArray(res) ? res : []);
    } catch (err) {
      setRules([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRules();
    fetchOperators();
  }, []);


  const fetchOperators = async () => {
    try {
      const res = await getOperators();
      console.log("Operators:", res);

      const filtered = res?.filter(
        (op) => op.paymentMode === "IMPS"
      );

      setOperators(filtered);

    } catch (err) {
      console.error("Operator API Error:", err);
    }
  };


  const handleOperatorUpdate = async () => {
    if (!selectedOperator) {
      alert("Select Operator");
      return;
    }

    try {
      const res = await updateOperator(
        null,
        `?operator=${selectedOperator}&enabled=${operatorStatus}&paymentMode=IMPS`
      );

      // ✅ SAVE RESPONSE
      setOperatorResponse(res);
      setShowResponseModal(true);

      // reset
      setShowOperatorModal(false);
      setSelectedOperator("");
      setOperatorStatus(true);

    } catch (err) {
      console.error(err);

      setOperatorResponse({
        message: "Something went wrong",
        isEnabled: false,
      });
      setShowResponseModal(true);
    } finally {

      fetchRules();
      fetchOperators();
    }
  };

  // ================= FORM =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRuleChange = (index, field, value) => {
    const updated = [...formData.rules];
    updated[index][field] = value;

    setFormData({ ...formData, rules: updated });
  };

  const addRuleRow = () => {
    setFormData((prev) => ({
      ...prev,
      rules: [
        ...prev.rules,
        {
          operator: "",
          percentage: "",
          priority: prev.rules.length + 1,
          active: true,
        },
      ],
    }));
  };

  const removeRuleRow = (index) => {
    const updated = formData.rules.filter((_, i) => i !== index);

    const reset = updated.map((r, i) => ({
      ...r,
      priority: i + 1,
    }));

    setFormData({ ...formData, rules: reset });
  };

  // ================= OPEN =================
  const openModal = () => {
    setEditMode(false);
    setFormData({
      minAmount: "",
      maxAmount: "",
      rules: [
        { operator: "", percentage: "", priority: 1, active: true },
        { operator: "", percentage: "", priority: 2, active: true },
        { operator: "", percentage: "", priority: 3, active: true },
        { operator: "", percentage: "", priority: 4, active: true },
        { operator: "", percentage: "", priority: 5, active: true },
        { operator: "", percentage: "", priority: 6, active: true },
        // { operator: "", percentage: "", priority: 7, active: true },
      ],
    });
    setShowModal(true);
  };

  // ================= EDIT =================
  const handleEdit = (slab) => {
    setEditMode(true);

    setFormData({
      minAmount: slab.minAmount,
      maxAmount: slab.maxAmount,
      rules: slab.rules.map((r, i) => ({
        operator: r.operator,
        percentage: r.percentage,
        priority: r.priority || i + 1,
        active: r.active ?? true,
      })),
    });

    setShowModal(true);
  };

  // ================= SUBMIT =================
  const handleSubmit = async () => {
    const payload = {
      paymentMode: "IMPS",
      minAmount: Number(formData.minAmount),
      maxAmount: Number(formData.maxAmount),
      rules: formData.rules.map((r) => ({
        operator: r.operator,
        percentage: Number(r.percentage),
        priority: Number(r.priority),
        active: r.active,
      })),
    };

    try {
      let res;

      if (editMode) {
        res = await updateRule(payload);
      } else {
        res = await createRule(payload);
      }

      if (res?.status === 202) {
        setErrorMsg(res.message);
        return;
      }

      setShowModal(false);
      fetchRules();
      setErrorMsg("");

    } catch (err) {
      setErrorMsg("Something went wrong");
    }
    finally {

      fetchRules();
      fetchOperators();
    }
  };

  // ================= UI =================
  return (
    <div className="p-6">

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {operators.map((op) => (
          <div
            key={op.id}
            className={`rounded-xl p-4 shadow-sm border 
        ${op.isEnabled
                ? "bg-gradient-to-r from-green-100 to-green-50 border-green-200"
                : "bg-gradient-to-r from-red-100 to-red-50 border-red-200"
              }`}
          >
            <p className="text-sm text-gray-500">IMPS Operator</p>

            <h3
              className={`text-lg font-semibold 
          ${op.isEnabled ? "text-green-700" : "text-red-700"}`}
            >
              {op.displayName}
            </h3>

            <span
              className={`inline-block mt-2 px-2 py-1 text-xs rounded
          ${op.isEnabled
                  ? "bg-green-200 text-green-800"
                  : "bg-red-200 text-red-800"
                }`}
            >
              {op.isEnabled ? "Active" : "Inactive"}
            </span>
          </div>
        ))}
      </div>

      {/* HEADER */}
      <div className="flex justify-between mb-6">
        <h2 className="text-xl font-semibold text-blue-600">
          IMPS Routing Rules
        </h2>

        <div className="flex gap-3">
          <button
            onClick={() => openModal()}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg"
          >
            + Add Rule
          </button>

          {/* ✅ NEW BUTTON */}
          <button
            onClick={() => setShowOperatorModal(true)}
            className="bg-purple-600 text-white px-4 py-2 rounded-lg"
          >
            Operator Handle
          </button>
        </div>
      </div>

      {/* TABLE */}
      <div className="bg-white border rounded-xl shadow overflow-hidden">
        <table className="w-full text-base">

          <thead className="bg-blue-50">
            <tr className="text-left text-gray-700">
              <th className="p-4 border">Payment</th>
              <th className="p-4 border">Range</th>
              <th className="p-4 border">Routing Details</th>
              <th className="p-4 border">Status</th>
              <th className="p-4 border">Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center p-6">
                  Loading...
                </td>
              </tr>
            ) : (
              rules.map((slab, i) => {
                const active = slab.rules?.every((r) => r.active);

                return (
                  <tr key={i} className="hover:bg-gray-50">

                    {/* Payment */}
                    <td className="p-4 border font-medium">
                      {slab.paymentMode}
                    </td>

                    {/* Range */}
                    <td className="p-4 border font-medium">
                      ₹{slab.minAmount} - ₹{slab.maxAmount}
                    </td>

                    {/* 🔥 ROUTING DETAILS (FIXED UX) */}
                    <td className="p-4 border">
                      <div className="space-y-2">
                        {slab.rules?.map((r, j) => (
                          <div
                            key={j}
                            className="flex justify-between items-center bg-gray-50 px-3 py-2 rounded-lg border"
                          >
                            {/* LEFT: Operator */}
                            <span className="font-semibold text-gray-800">
                              {r.operator}
                            </span>

                            {/* RIGHT: % + Priority */}
                            <div className="flex items-center gap-3">

                              <span
                                className={`px-2 py-1 text-sm rounded ${r.percentage === 100
                                  ? "bg-green-100 text-green-600"
                                  : r.percentage === 0
                                    ? "bg-gray-200 text-gray-500"
                                    : "bg-yellow-100 text-yellow-600"
                                  }`}
                              >
                                {r.percentage}%
                              </span>

                              <span className="text-xs bg-blue-100 text-blue-600 px-2 py-1 rounded">
                                P{r.priority}
                              </span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </td>

                    {/* Status */}
                    <td className="p-4 border">
                      <span
                        className={`px-3 py-1 text-sm rounded-full ${active
                          ? "bg-green-100 text-green-600"
                          : "bg-red-100 text-red-600"
                          }`}
                      >
                        {active ? "Active" : "Partial"}
                      </span>
                    </td>

                    {/* Action */}
                    <td className="p-4 border">
                      <button
                        onClick={() => handleEdit(slab)}
                        className="text-blue-600 font-medium hover:underline"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4">
          <div className="bg-white rounded-xl w-full max-w-md flex flex-col max-h-[90vh] shadow-xl">

            {/* ── Fixed header ── */}
            <div className="px-6 pt-6 pb-4 border-b flex-shrink-0">
              <h3 className="text-lg font-semibold text-blue-600">
                {editMode ? "Edit Rule" : "Add Rule"}
              </h3>
            </div>

            {/* ── Scrollable body ── */}
            <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">

              {/* RANGE */}
              <div className="grid grid-cols-2 gap-2">
                <input
                  name="minAmount"
                  value={formData.minAmount}
                  onChange={handleChange}
                  placeholder="Min Amount"
                  className="border p-2 rounded"
                />
                <input
                  name="maxAmount"
                  value={formData.maxAmount}
                  onChange={handleChange}
                  placeholder="Max Amount"
                  className="border p-2 rounded"
                />
              </div>

              {/* RULES */}
              <div className="space-y-3">
                {formData.rules.map((rule, i) => (
                  <div key={i} className="border p-3 rounded bg-gray-50">
                    <div className="flex justify-between mb-2">
                      <span className="text-sm font-semibold">Rule {i + 1}</span>
                    </div>
                    <div className="grid grid-cols-3 gap-2">
                      <select
                        value={rule.operator}
                        onChange={(e) => handleRuleChange(i, "operator", e.target.value)}
                        className="border p-2 rounded text-sm"
                      >
                        <option value="">Operator</option>
                        <option value="AERONPAY">AERONPAY</option>
                        <option value="NIFFI">NIFFI</option>
                        <option value="TRAMO">TRAMO</option>
                        <option value="DILLIPAY">DILLIPAY</option>
                        <option value="FINZEP">FINZEP</option>
                        <option value="SOLITECK">SOLITECK</option>
                        <option value="VIMOPAY">VIMOPAY</option>
                      </select>
                      <input
                        type="number"
                        value={rule.percentage}
                        onChange={(e) => handleRuleChange(i, "percentage", e.target.value)}
                        placeholder="%"
                        className="border p-2 rounded text-sm"
                      />
                      <input
                        value={rule.priority}
                        readOnly
                        className="border p-2 rounded bg-gray-100 text-sm"
                      />
                    </div>
                  </div>
                ))}
              </div>

              {/* ERROR */}
              {errorMsg && (
                <div className="text-red-500 text-sm">{errorMsg}</div>
              )}
            </div>

            {/* ── Fixed footer ── */}
            <div className="px-6 py-4 border-t flex-shrink-0 flex justify-end gap-2">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-200 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                Save
              </button>
            </div>

          </div>
        </div>
      )}


      {showOperatorModal && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center">
          <div className="bg-white w-full max-w-md p-6 rounded-xl shadow-xl">

            <h3 className="text-lg font-semibold mb-4 text-purple-600">
              Operator Handle
            </h3>

            <div className="space-y-4">

              {/* DROPDOWN */}
              <select
                value={selectedOperator}
                onChange={(e) => setSelectedOperator(e.target.value)}
                className="w-full border p-2 rounded bg-white"
              >
                <option value="">Select Operator</option>
                <option value="NIFFI">NIFFI</option>
                <option value="TRAMO">TRAMO</option>
                <option value="AERONPAY">AERONPAY</option>
                <option value="DILLIPAY">DILLIPAY</option>
                <option value="FINZEP">FINZEP</option>
                <option value="SOLITECK">SOLITECK</option>
                <option value="VIMOPAY">VIMOPAY</option>
              </select>

              {/* TOGGLE */}
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Status</span>

                <button
                  onClick={() => setOperatorStatus(!operatorStatus)}
                  className={`px-4 py-1 rounded-full text-sm ${operatorStatus
                    ? "bg-green-100 text-green-600"
                    : "bg-red-100 text-red-600"
                    }`}
                >
                  {operatorStatus ? "Active" : "Inactive"}
                </button>
              </div>

            </div>

            {/* ACTION BUTTONS */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowOperatorModal(false)}
                className="px-4 py-2 bg-gray-200 rounded"
              >
                Cancel
              </button>

              <button
                onClick={handleOperatorUpdate}
                className="px-4 py-2 bg-purple-600 text-white rounded"
              >
                Update
              </button>
            </div>

          </div>
        </div>
      )}


      {showResponseModal && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
          <div className="bg-white w-full max-w-sm rounded-xl p-6 text-center shadow-xl">

            {/* ICON */}
            <div className="mb-3">
              {operatorResponse?.isEnabled ? (
                <div className="text-green-500 text-3xl">✅</div>
              ) : (
                <div className="text-red-500 text-3xl">⚠️</div>
              )}
            </div>

            {/* TITLE */}
            <h3 className="text-lg font-semibold mb-2">
              {operatorResponse?.isEnabled
                ? "Operator Enabled"
                : "Operator Disabled"}
            </h3>

            {/* MESSAGE */}
            <p className="text-sm text-gray-600 mb-5">
              {operatorResponse?.displayName || operatorResponse?.operator}{" "}
              is now{" "}
              {operatorResponse?.isEnabled ? "ACTIVE" : "INACTIVE"}
            </p>

            {/* OK BUTTON */}
            <button
              onClick={() => setShowResponseModal(false)}
              className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default IMPSRouting;